module.exports = __webpack_public_path__ + "static/media/recontra.63468a6f.svg";